import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Card, Text } from 'react-native-paper';
import { useThemeSettings } from '../ThemeProvider';
import { ITableContent } from '../features/immersive-news-article/types';
import { FULL_WIDTH } from '../shared/constants/dimension';

interface TableContentProps {
  content: ITableContent[];
  style?: object;
}

export const TableContent: React.FC<TableContentProps> = ({ content, style = {} }) => {
  const { theme } = useThemeSettings();

  return (
    <View style={{gap:16}}>
      {content.map((table, tableIndex) => (
        <Card key={tableIndex} style={style} mode="elevated">
          {table.title && (
            <View>
              <Text
                style={[styles.headerCell, { color: theme?.colors?.primary, borderTopRightRadius: 8, borderTopLeftRadius: 8 }]}
                variant="headlineSmall"
              >
                {table.title}
              </Text>
            </View>
          )}
          <View>
            {Object.entries(table.data).map(([key, value], index) => (
              <View
                key={index}
                style={[
                  styles.row,
                  { borderBottomColor: theme?.colors?.surfaceBg },
                  index === Object.entries(table.data).length - 1 && styles.lastRow
                ]}
              >
                <View style={[styles.bodyCell, { flex: 0.4, borderRightWidth: 2, borderRightColor: theme?.colors?.surfaceBg }]}>
                  <Text
                    style={[styles.categoryText, { color: theme?.colors?.secondary }]}
                    variant="bodySmall"
                  >
                    {key}
                  </Text>
                </View>
                <View style={[styles.bodyCell, { flex: 0.6 }]}>
                  <Text
                    style={[styles.descriptionText, { color: theme?.colors?.bodyText }]}
                    variant="bodySmall"
                  >
                    {value}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        </Card>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent'
  },
  content: {
    gap: 16,
  },
  row: {
    flexDirection: 'row',
    borderBottomWidth: 2,
  },
  headerCell: {
    padding: 16,
    textAlign: 'center',
  },
  lastRow: {
    borderBottomWidth: 0,
  },
  bodyCell: {
    padding: 16,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  categoryText: {
    fontWeight: '600',
    textAlign: 'left',
    maxWidth: FULL_WIDTH
  },
  descriptionText: {
    lineHeight: 20,
    textAlign: 'left',
    maxWidth: FULL_WIDTH
  },
});

export default TableContent;
